import { Helmet } from "react-helmet-async";

const SITE = "Intellix";
const BASE_URL = "https://intellix.fr";

const defaults = {
  title: `${SITE} | Transformation numérique des PME`,
  description:
    "Intellix accompagne les PME dans leur transformation numérique : Microsoft 365, Copilot, Purview, Zero Trust, SOC, IA générative, licences Microsoft, hébergement souverain.",
};

export function SEO({ title, description, path = "", type = "website", image }) {
  const t = title ? `${title} | ${SITE}` : defaults.title;
  const d = description || defaults.description;
  const url = `${BASE_URL}${path}`;
  const img = image || `${BASE_URL}/logo-intellix.webp`;

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={SITE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
